import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import './../css/Style.css';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/poppins';
import flagCircle from '../images/india_flag_icon.png';
import { ToastContainer, toast } from 'react-toastify';
import LoggedInHeader from '../subComponents/LoggedInHeader';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PopupCIDetails from '../subComponents/PopupCIDetails';
import PageLoader from '../subComponents/PageLoader';
import UserService from '../services/UserService';
import OtpInput from 'react-otp-input';

const VendorDetailsChange = forwardRef((props, ref) => {
    const { changeVendorDetails, vendorBack } = props;
    const [accountInfo, setAccountInfo] = useState(JSON.parse(sessionStorage.getItem('orderDetails')));
    const [vendorCode, setVendorCode] = useState(sessionStorage.getItem('stg_vendor_code'));
    const [vendorName, setVendorName] = useState(sessionStorage.getItem('stg_vendor_name'));
    const [mobile, setMobile] = useState(sessionStorage.getItem('stg_vendor_mobile'));
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showSaveAndCancel, setShowSaveAndCancel] = useState(false);
    const [vendorUpdated, setVendorUpdated] = useState(false);
    const [vendorInfo, setVendorInfo] = useState([]);
    const [vendorId, setVendorId] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(true);
    const [show, setShow] = useState(false);
    const [showPopupCIDetails, setShowPopupCIDetails] = useState(false);
    const [loading, setLoading] = useState(false);
    const [otp, setOtp] = useState('');
    const [showOtpField, setShowOtpField] = useState(false);
    const [otpTimer, setOtpTimer] = useState(0);
    const [canResendOtp, setCanResendOtp] = useState(true);
    const [otpSent, setOtpSent] = useState(false);
    

    const handleClose = () => {
        setShow(false);
        cancel();
    };
    const handleShow = () => {
        setShow(true);
        setMobile(sessionStorage.getItem('stg_vendor_mobile'));
        setVendorCode(sessionStorage.getItem('stg_vendor_code'));
        setVendorName(sessionStorage.getItem('stg_vendor_name'));
        
        // Reset OTP states when modal opens
        setOtp('');
        setShowOtpField(false);
        setOtpSent(false);
        setOtpTimer(0);
        setCanResendOtp(true);
        setShowErrorMsg(false);
    }

    useImperativeHandle(ref, () => ({
        handleShow
    }));
    
    const msg = (str) => toast.info(str, {
        position: "top-center"
    });

    useEffect(() => {
        setMobile(sessionStorage.getItem('stg_vendor_mobile'));
        setVendorCode(sessionStorage.getItem('stg_vendor_code'));
        setVendorName(sessionStorage.getItem('stg_vendor_name'));
        
    }, []);

    // OTP timer effect
    useEffect(() => {
        let interval;
        if (otpTimer > 0) {
            interval = setInterval(() => {
                setOtpTimer(timer => timer - 1);
            }, 1000);
        } else if (otpTimer === 0 && !canResendOtp) {
            setCanResendOtp(true);
        }
        return () => clearInterval(interval);
    }, [otpTimer, canResendOtp]);

    const handleChangeVendorName = (event) => {
        setVendorName(event.target.value);
    };

    const handleChangeVendorCode = (event) => {
        setVendorCode(event.target.value);
    };

    const handleChangeVendorMobile = (event) => {
        const mobileNumber = event.target.value.replace(/\D/g, '');
        setMobile(mobileNumber);
        
        // Reset OTP states when mobile number changes
        setOtp('');
        setShowOtpField(false);
        setOtpSent(false);
        setOtpTimer(0);
        setCanResendOtp(true);
        setShowErrorMsg(false);
        
        if (mobileNumber.length === 10) {
            // Check if the entered mobile number is same as current vendor's mobile
            const currentVendorMobile = (sessionStorage.getItem('stg_vendor_mobile') || '').toString();
            if (mobileNumber == currentVendorMobile) {
                // Same mobile number, just update the display fields without OTP using current state
                // No need to call sessionStorage again since we already have the values in state
                setVendorCode(sessionStorage.getItem('stg_vendor_code'));
                setVendorName(sessionStorage.getItem('stg_vendor_name'));
                setShowOtpField(false);
                setShowSaveAndCancel(false);
                setShowErrorMsg(false);
                msg("This is your current vendor. No change required.");
                return;
            }
            getVendorInfo(mobileNumber, "handleChangeVendorMobile");
        } else {
            setVendorCode("");
            setVendorName("");
            setShowSaveAndCancel(false);
            // Clear vendor states when mobile is not valid
            setVendorId('');
            setVendorInfo([]);
        }
    };

    const getVendorInfo = (mobileNumber, source) => {
        const accountId = JSON.parse(sessionStorage.getItem('orderDetails')).id;
        if(!mobileNumber){
            msg("Vendor mobile number is missing.");
            setShowSaveAndCancel(false);
            return;
        }
        setLoading(true);
        UserService.getVenderDetails(accountId, mobileNumber).then(res => {
            if (res.data.success) {
                // sessionStorage.removeItem('vendorInfo');
                // sessionStorage.setItem("vendorInfo", JSON.stringify(res.data));
                setVendorInfo(res.data);
                setVendorCode(res.data.employee_code);
                setVendorId(res.data.id);
                setVendorName(res.data.name);
                setMobile(res.data.mobile);
                setShowErrorMsg(false);
                setShowSaveAndCancel(false); // Don't show save button until OTP is entered
                let orderDetailsCh = sessionStorage.getItem('orderDetails');
                if (orderDetailsCh) {
                    orderDetailsCh = JSON.parse(orderDetailsCh);
                    orderDetailsCh.vendorCode = res.data.employee_code;
                    orderDetailsCh.vendorId = res.data.id;
                    orderDetailsCh.vendorMobile = res.data.mobile;
                    orderDetailsCh.vendorName = res.data.name;
                    sessionStorage.setItem('orderDetails', JSON.stringify(orderDetailsCh));
                }
                
                // Send OTP to vendor's mobile number
                if (source !== "cancel") {
                    sendOtpToVendor(res.data.mobile);
                }
                
                setLoading(false);
            } else {
                setVendorCode("NA");
                setVendorName("NA");
                setShowErrorMsg(true);
                setShowSaveAndCancel(false);
                setShowOtpField(false);
                setOtpSent(false);
                setLoading(false);
            }
        }).catch(e => {
            msg(`Something went wrong - ${e}`);
            setLoading(false);
        });
    };

    const cancel = () => {
        // getVendorInfo(sessionStorage.getItem("stg_vendor_mobile"), "cancel");
        setVendorCode(sessionStorage.getItem("stg_vendor_code"));
        setVendorName(sessionStorage.getItem("stg_vendor_name"));
        setMobile(sessionStorage.getItem("stg_vendor_mobile"));
        
        // Reset OTP states
        setOtp('');
        setShowOtpField(false);
        setOtpSent(false);
        setOtpTimer(0);
        setCanResendOtp(true);
    };

    const sendOtpToVendor = (vendorMobile) => {
        setLoading(true);
        const customerMobileNumber = accountInfo ? accountInfo.mobile : null;

        UserService.generateOtp(vendorMobile, "vendor-change-otp", null, customerMobileNumber).then(res => {
            if (res.success) {
                setShowOtpField(true);
                setOtpSent(true);
                setOtpTimer(30); // 30 seconds timer
                setCanResendOtp(false);
                msg("OTP sent to vendor's mobile number");
            } else {
                msg(res.message || "Failed to send OTP");
                setShowOtpField(false);
            }
            setLoading(false);
        }).catch(e => {
            msg(`Failed to send OTP - ${e}`);
            setShowOtpField(false);
            setLoading(false);
        });
    };

    const resendOtp = () => {
        if (canResendOtp) {
            sendOtpToVendor(mobile);
        }
    };

    const handleOtpChange = (otpValue) => {
        setOtp(otpValue);
        // Show save button when OTP is fully entered
        if (otpValue.length === 6) {
            setShowSaveAndCancel(true);
        } else {
            setShowSaveAndCancel(false);
        }
    };

    const saveVendorDetails = () => {
        if (!otp || otp.length !== 6) {
            msg("Please enter a valid 6-digit OTP");
            return;
        }
        
        if (vendorId !== "") {
            setLoading(true);
            const accountId = JSON.parse(sessionStorage.getItem('orderDetails')).id;
            // Call updateVendor with OTP - backend will handle OTP verification
            UserService.updateVendor(vendorId, accountId, parseInt(otp), mobile, "vendor-change-otp").then(res => {
                if (res.data.success) {
                    setShowErrorMsg(false);
                    setShowSaveAndCancel(false);
                    sessionStorage.setItem("vendorInfo", JSON.stringify(vendorInfo));
                    setVendorUpdated(true);
                    sessionStorage.setItem("stg_vendorUpdated", true);
                    sessionStorage.setItem("stg_vendor_mobile", mobile);
                    sessionStorage.setItem("stg_vendor_name", vendorName);
                    sessionStorage.setItem("stg_vendor_code", vendorCode);
                    msg("Vendor has been updated successfully");
                    if(vendorBack){
                        changeVendorDetails();
                    }
                    setLoading(false);
                    
                } else {
                    // setShowErrorMsg(true);
                    setShowSaveAndCancel(false);
                    msg(res.data.message || "Failed to update vendor details");
                    setLoading(false);
                }
            }).catch(e => {
                if (e.response && e.response.data && e.response.data.message) {
                    msg(e.response.data.message);
                } else {
                    msg(`Something went wrong - ${e.message || e}`);
                }
                setLoading(false);
            });
        } else {
            msg("Vendor information is missing");
        }
        sessionStorage.setItem("stg_Venodr_Post_MobileNumber", mobile);
    };

    const showCIDetails = () => {
        handleClose();
        setShowPopupCIDetails(true);
    };
    const closeCIDetailsBox = () => {
        setShowPopupCIDetails(false);
    };

    return (
        <>
        { loading && <PageLoader/> }
        <Modal
            show={show}
            onHide={handleClose}
            // backdrop="static"
            // keyboard={false}
            // size="md"  
            aria-labelledby="contained-modal-title-vcenter"  
            centered 
            id="model_custome_css"
            >
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="col-md-12 col-12">
                        <h5 className="rmc-heading mt-3 mb-0 text-center blackClourV2">Change Vendor Details</h5>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="col-md-12 col-12">
                    
                    <div className="scheme-box change-vendor-details">
                        <div className="row pt-2 pb-2">
                            <div className="col-md-12 form-group-model">
                                <div className="form-group">
                                    <label htmlFor="" className="vChangeLabel">Vendor Registered Number
                                        <small className="info-text">
                                            To update the vendor, please provide the mobile number of your new vendor
                                        </small>
                                    </label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-white"><img src={flagCircle} className='flag fontNJ'/>&nbsp;+91</span>
                                        </div>
                                        <input className="form-control" name="mobile" value={mobile} type="tel" pattern="[0-9]*" onChange={handleChangeVendorMobile} />
                                    </div>
                                    
                                    {showErrorMsg &&
                                        <div className="error-msg text-center">
                                            <p className="mt-2 mb-0" style={{fontSize:"13px"}}>There is no active vendor registered with us on the given number.<br></br> Please reach out to your <a className='contact-manager' onClick={showCIDetails}>Relationship Manager</a> or drop a mail to the BPO team at:
                                            <strong className='ml-1'>subscription@hindustantimes.com | 011-67764242”</strong></p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row pt-2 pb-2">
                            <div className="col-md-6 form-group-model">
                                <div className="form-group">
                                    <label htmlFor="" className="vChangeLabel"> Vendor Name</label>
                                    <input type="text" value={vendorName} name="vendorName" onChange={handleChangeVendorName} className="form-control" disabled />
                                </div>
                            </div>
                            <ToastContainer />
                            <div className="col-md-6 form-group-model">
                                <div className="form-group">
                                    <label htmlFor="" className="vChangeLabel">Vendor Code</label>
                                    <input type="text" value={vendorCode} name="vendorCode" onChange={handleChangeVendorCode} className="form-control" disabled />
                                </div>
                            </div>
                        </div>

                        {showOtpField &&
                            <div className="otp-section mt-3">
                                <div className="row">
                                    <div className="col-md-12 form-group-model">
                                        <div className="form-group">
                                            <label htmlFor="" className="vChangeLabel">Enter OTP
                                                <small className="info-text">
                                                    Please enter the 6-digit OTP sent to vendor's mobile number
                                                </small>
                                            </label>
                                            <div className="d-flex justify-content-center px-1">
                                                <OtpInput
                                                    value={otp}
                                                    onChange={handleOtpChange}
                                                    numInputs={6}
                                                    inputType="number"
                                                    shouldAutoFocus={true}
                                                    renderSeparator={<span style={{width: '0.2em'}}></span>}
                                                    renderInput={(props) => <input {...props} autoComplete="one-time-code" />}
                                                    containerStyle={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        flexWrap: 'nowrap',
                                                        gap: '0px',
                                                        width: '100%'
                                                    }}
                                                    inputStyle={{
                                                        width: "100%",
                                                        maxWidth: "40px",
                                                        height: "2.5em",
                                                        textAlign: "center",
                                                        background: "#FFFFFF 0% 0% no-repeat padding-box",
                                                        border: "1px solid #CDCDCD",
                                                        borderRadius: "8px",
                                                        fontSize: "16px",
                                                        margin: "0 1px",
                                                        flex: "1 1 auto"
                                                    }}
                                                />
                                            </div>
                                            
                                            <div className="otp-controls mt-2 text-center">
                                                <div className="resend-section">
                                                    {canResendOtp ? (
                                                        <button 
                                                            className="btn btn-link p-0" 
                                                            onClick={resendOtp}
                                                            style={{fontSize: "13px"}}
                                                        >
                                                            Resend OTP
                                                        </button>
                                                    ) : (
                                                        <small className="text-muted">
                                                            Resend OTP in {otpTimer}s
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
            {showSaveAndCancel &&
                <div className="text-center vchange-btn">
                    {/* <a onClick={cancel} className="btn btn-light save-btn mr-lg-4">Cancel</a> */}
                    <a onClick={saveVendorDetails} className="btn btn-dark save-btn">CHANGE VENDOR</a>
                </div>
            }
            </Modal.Footer>
        </Modal>
        <PopupCIDetails
            isOpenCI={showPopupCIDetails}
            onCloseCI={closeCIDetailsBox}>
        </PopupCIDetails>
        </>
    );
});

export default VendorDetailsChange;
